export default "__VITE_ASSET__C8mWH84i__"